import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { COMPANY, PROJECT, LIVECAMALL, TIMELAPSEALL } from "../../services/actions";
import { MdBatteryChargingFull, MdBolt, MdOutlineSolarPower } from "react-icons/md";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Select, MenuItem, InputLabel, FormControl } from "@mui/material";
import "./main.css";

const statusStyles = {
    online: {
        borderColor: "#22c55e",
        glow: "0 0 12px rgba(34, 197, 94, 0.35)",
        badgeColor: "#22c55e",
    },
    warning: {
        borderColor: "#facc15",
        glow: "0 0 12px rgba(250, 204, 21, 0.35)",
        badgeColor: "#facc15",
    },
    offline: {
        borderColor: "#ef4444",
        glow: "0 0 12px rgba(239, 68, 68, 0.35)",
        badgeColor: "#ef4444",
    },
};
const gray = {
    "backgroundColor": "#f1f1f1",
    "color": "#94a3b8", padding: 8,
    borderRadius: 16
}
function DeviceRow({ title, icon, data, progress = null, exclude = [], style = {}, replaceKey = "" }) {
    const gray = {
        "backgroundColor": "#f1f1f1",
        "color": "#94a3b8", padding: 8,
        borderRadius: 16
    }
    return <div className="section device-row" style={gray}>
        <div style={{ display: 'flex', width: '100%', gap: 12 }}>
            <div className="device-icon-container" style={{ padding: 10, minWidth: 52, backgroundColor: '#ffffffff', borderRadius: 12, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                {icon}
                <span style={{ color: '#94a3b8', fontWeight: 500, fontSize: 10, textTransform: 'uppercase' }}>{title}</span>
            </div>
            <div style={{ width: '100%' }}>
                <div className="battery-row">
                    {progress && data.map((d) => {
                        if (d.name == progress) {
                            return <>
                                <span className="input-label text-title" style={{ fontWeight: 600, color: "#464747ff", fontSize: 14 }}>{d.value || 0}%</span>
                                {/* <div className="progress">
                                    <div
                                        className="progress-bar"
                                        style={{
                                            width: `${d.value || 0}%`,
                                            backgroundColor: style.borderColor,
                                        }}
                                    />
                                </div> */}
                            </>
                        }
                    })}
                </div>
                <div className="grid">
                    {data.map((d) => {
                        if (exclude.includes(d.name)) return
                        console.log("NAME", d.name, d.name.startsWith("Temp"))
                        const n = d.name.startsWith("Battery Temperature") ? "Temp" : d.name
                        return <div>
                            <strong className="input-label text-value" style={{ fontWeight: 600, color: "#4f5150ff", fontSize: 14 }}>{d.value || 0}</strong>
                            <span className="text-title" style={{ fontWeight: 400, color: "#464747ff", fontSize: 10 }}>{n.replaceAll(replaceKey, "")}</span>
                        </div>
                    })}
                </div>
            </div>
        </div>
    </div>
}

export default function DeviceCard({
    title = "WL-01",
    location = "Tower A · North",
    status = "online",
    battery = 82,
    solarVoltage = "18.5 V",
    solarCurrent = "4.2 A",
    solarPower = "77 W",
    solarData = [],
    batteryData = [],
    loadData = [],
}) {
    const style = statusStyles[status] || statusStyles.offline;
    const [openLocationForm, setOpenLocationForm] = useState(false);
    const [company, setCompany] = useState("");
    const [project, setProject] = useState("");
    const [camera, setCamera] = useState("");

    const dispatch = useDispatch();
    const companyState = useSelector((state) => state?.companyState);
    const projectState = useSelector((state) => state?.projectState);
    const livecamallState = useSelector((state) => state?.livecamallState);
    const timelapseallState = useSelector((state) => state?.timelapseallState);

    const combinedCameras = React.useMemo(() => {
        const list = [];
        const seenNames = new Set();
        const addCamera = (cam) => {
            if (cam && cam.camera_name && !seenNames.has(cam.camera_name)) {
                seenNames.add(cam.camera_name);
                list.push(cam);
            }
        };
        (livecamallState?.data?.results || []).forEach(addCamera);
        (timelapseallState?.data?.results || []).forEach(addCamera);
        return list;
    }, [livecamallState?.data?.results, timelapseallState?.data?.results]);

    useEffect(() => {
        if (openLocationForm) {
            dispatch({ type: `${COMPANY}_GET`, payload: 0 });
        }
    }, [openLocationForm, dispatch]);

    const handleCompanyChange = (e) => {
        const val = e.target.value;
        setCompany(val);
        setProject("");
        setCamera("");
        if (val) {
            dispatch({
                type: `${PROJECT}_GET`,
                payload: `project/0/?filter_by={"company":"${val}"}`,
            });
        }
    };

    const handleProjectChange = (e) => {
        const val = e.target.value;
        setProject(val);
        setCamera("");
        if (val) {
            dispatch({
                type: `${LIVECAMALL}_GET`,
                payload: `livecam/0/?filter_by={"project_id":"${val}"}`
            });
            dispatch({
                type: `${TIMELAPSEALL}_GET`,
                payload: `timelapse/0/?filter_by={"project_id":"${val}"}`
            });
        }
    };

    const isDark = localStorage?.selectedTheme === 'dark';
    const textColor = isDark ? 'white' : 'black';

    return (
        <div
            className="device-card shadow"
            style={{
                // border: `2px solid ${style.borderColor}`,
                boxShadow: style.glow, height: '100%',
                backgroundColor: 'white',
                color: 'black'
            }}
        >
            <div className="device-header input-label">
                <div>
                    <div style={{ fontSize: 14, fontWeight: 500 }}>{title}</div>
                    <p
                        style={{ fontSize: 12, fontWeight: 500, color: '#1976d2', cursor: 'pointer', textDecoration: 'underline' }}
                        onClick={() => setOpenLocationForm(true)}
                    >
                        {location}
                    </p>
                </div>
                <span style={{ display: 'flex', gap: 2, alignItems: 'center', border: `1px solid ${style.badgeColor}`, padding: '2px 12px', borderRadius: 12 }}>
                    <div
                        className="status-badge"
                        style={{ backgroundColor: style.badgeColor, width: 5, height: 5, padding: 4 }}
                    >
                    </div>
                    <span
                        style={{ color: style.badgeColor }}
                    >
                        {status}
                    </span>
                </span>
            </div>

            <DeviceRow
                title={"SOLAR"}
                icon={<MdOutlineSolarPower style={{ fontSize: 24, color: '#0088ff' }} />}
                data={solarData}
                exclude={["Load Status"]}
                style={style}
                replaceKey="PV"
            />

            <DeviceRow
                title={"BATTERY"}
                icon={<MdBatteryChargingFull style={{ fontSize: 24, color: style?.badgeColor }} />}
                data={batteryData}
                exclude={["Charging Status", "Battery SOC", "Maximum Battery Voltage", "Minimum Battery Voltage"]}
                style={style}
                progress={"Battery SOC"}
                replaceKey="Battery"
            />


            <DeviceRow
                title={"LOAD"}
                icon={<MdBolt style={{ fontSize: 24, color: statusStyles.warning.badgeColor }} />}
                data={loadData}
                exclude={["Load Status"]}
                style={style}
                replaceKey="Load"
            />

            <div style={{ display: 'flex', gap: 2, fontSize: 13, justifyContent: 'space-between' }}>
                <div>
                    <span>Camera</span>
                    <span> ON</span>
                </div>
                <div>
                    <span>Load</span>
                    <span style={{ color: style?.badgeColor }}> ON</span>
                </div>
            </div>

            <Dialog
                open={openLocationForm}
                onClose={() => setOpenLocationForm(false)}
                fullWidth
                maxWidth="sm"
                PaperProps={{
                    sx: {
                        backgroundColor: localStorage?.selectedTheme === 'dark' ? 'rgba(30, 30, 30, 0.85)' : 'rgba(255, 255, 255, 0.95)',
                        backdropFilter: 'blur(50px)',
                        borderRadius: 10,
                        color: localStorage?.selectedTheme === 'dark' ? 'white' : 'black',
                    }
                }}
            // sx={{
            //     '& .MuiBackdrop-root': {
            //         backgroundColor: 'rgba(0, 0, 0, 0.4)'
            //     }
            // }}
            >
                <DialogTitle sx={{ color: textColor }}>Update Camera Info</DialogTitle>
                <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
                    <FormControl fullWidth size="small" sx={{ mt: 1 }}>
                        <InputLabel sx={{ color: textColor }}>Company</InputLabel>
                        <Select
                            value={company}
                            label="Company"
                            onChange={handleCompanyChange}
                            sx={{
                                borderRadius: '10px',
                                color: textColor,
                                '.MuiOutlinedInput-notchedOutline': { borderColor: isDark ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.23)' },
                                '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: textColor },
                                '.MuiSvgIcon-root': { color: textColor }
                            }}
                            MenuProps={{
                                PaperProps: {
                                    sx: {
                                        backgroundColor: localStorage?.selectedTheme === 'dark' ? 'rgba(30, 30, 30, 0.85)' : 'rgba(255, 255, 255, 0.8)',
                                        backdropFilter: 'blur(50px)',
                                        color: localStorage?.selectedTheme === 'dark' ? 'white' : 'black',
                                    }
                                }
                            }}
                        >
                            {companyState?.data?.results?.map((c) => (
                                <MenuItem key={c.id} value={c.id}>{c.company_name}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <FormControl fullWidth size="small">
                        <InputLabel sx={{ color: textColor }}>Project</InputLabel>
                        <Select
                            value={project}
                            label="Project"
                            onChange={handleProjectChange}
                            sx={{
                                borderRadius: '10px',
                                color: textColor,
                                '.MuiOutlinedInput-notchedOutline': { borderColor: isDark ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.23)' },
                                '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: textColor },
                                '.MuiSvgIcon-root': { color: textColor }
                            }}
                            MenuProps={{
                                PaperProps: {
                                    sx: {
                                        backgroundColor: localStorage?.selectedTheme === 'dark' ? 'rgba(30, 30, 30, 0.85)' : 'rgba(255, 255, 255, 0.8)',
                                        backdropFilter: 'blur(50px)',
                                        color: localStorage?.selectedTheme === 'dark' ? 'white' : 'black',
                                    }
                                }
                            }}
                        >
                            {projectState?.data?.results?.map((p) => (
                                <MenuItem key={p.id} value={p.id}>{p.project_name}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <FormControl fullWidth size="small">
                        <InputLabel sx={{ color: textColor }}>Camera</InputLabel>
                        <Select
                            value={camera}
                            label="Camera"
                            onChange={(e) => setCamera(e.target.value)}
                            sx={{
                                borderRadius: '10px',
                                color: textColor,
                                '.MuiOutlinedInput-notchedOutline': { borderColor: isDark ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.23)' },
                                '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: textColor },
                                '.MuiSvgIcon-root': { color: textColor }
                            }}
                            MenuProps={{
                                PaperProps: {
                                    sx: {
                                        backgroundColor: localStorage?.selectedTheme === 'dark' ? 'rgba(30, 30, 30, 0.85)' : 'rgba(255, 255, 255, 0.8)',
                                        backdropFilter: 'blur(50px)',
                                        color: localStorage?.selectedTheme === 'dark' ? 'white' : 'black',
                                    }
                                }
                            }}
                        >
                            {combinedCameras.map((cam) => (
                                <MenuItem key={cam.camera_name} value={cam.id}>{cam.camera_name}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </DialogContent>
                <DialogActions sx={{ padding: 3 }}>
                    <Button sx={{ borderRadius: '10px' }} onClick={() => setOpenLocationForm(false)}>Cancel</Button>
                    <Button variant="contained" sx={{ borderRadius: '10px' }} onClick={() => setOpenLocationForm(false)}>Save</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}